import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const PackageCards = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/iletisim');
  };

  const packages = [
    {
      name: 'Başlangıç Paketi',
      subtitle: 'Dijital Varlık Oluşturma',
      price: '64.000 TL',
      originalPrice: '79.000 TL',
      discount: '%19',
      saving: '15.000 TL',
      slogan: 'Yeni başlayan işletmeler için profesyonel seviyede dijital temel atma paketi',
      target: 'Yeni başlayan işletmeler',
      features: [
        {
          category: 'Sosyal Medya Yönetimi',
          items: ['8 Post tasarımı', '4 Story içeriği', 'Temel içerik stratejisi', 'Hashtag planlaması']
        },
        {
          category: 'Reklam Yönetimi',
          items: ['1 kampanya kurulumu', 'Hedef kitle belirleme', 'Aylık optimizasyon', 'Temel performans raporu']
        },
        {
          category: 'Web Tasarım',
          items: ['1-5 sayfa kurumsal site', 'Responsive tasarım', 'SSL sertifikası', 'Hız optimizasyonu']
        },
        {
          category: 'CRM Kurulumu',
          items: ['Temel müşteri kayıt sistemi', 'Pipeline yönetimi', 'İletişim takibi', 'Temel raporlama']
        },
        {
          category: 'Marka Kimliği',
          items: ['Profesyonel logo tasarımı', 'Renk paleti oluşturma', 'Tipografi seti', 'Temel kullanım rehberi']
        },
        {
          category: 'Video İçerik',
          items: ['2 reel video üretimi', 'Temel montaj', 'Müzik & efekt', 'Platform optimizasyonu']
        }
      ],
      borderColor: 'border-[#007dff]',
      accentColor: 'bg-[#007dff]',
      popular: false,
    },
    {
      name: 'Profesyonel Paket',
      subtitle: 'Düzenli Büyüme & Performans',
      price: '89.000 TL',
      originalPrice: '114.000 TL',
      discount: '%22',
      saving: '25.000 TL',
      slogan: 'Etkileşim ve satış odaklı, rekabette güçlenmek isteyen markalar için',
      target: 'Büyüyen işletmeler',
      features: [
        {
          category: 'Sosyal Medya Yönetimi',
          items: ['12 Post tasarımı', '8 Story içeriği', 'Aktif moderasyon', 'Haftalık performans raporu', 'Etkileşim analizi']
        },
        {
          category: 'Reklam Yönetimi',
          items: ['3 kampanya yönetimi', 'Pixel & Analytics kurulumu', 'Dönüşüm optimizasyonu', 'A/B test başlangıç', 'Haftalık optimizasyon']
        },
        {
          category: 'Web Tasarım',
          items: ['5-10 sayfa profesyonel site', 'Gelişmiş UI/UX tasarım', 'Form otomasyonu', 'SEO temel optimizasyon', 'Hız & güvenlik']
        },
        {
          category: 'CRM Otomasyon',
          items: ['Müşteri segmentasyonu', 'Otomatik teklif sistemi', 'E-posta & SMS akışları', 'Lead skorlama', 'Gelişmiş raporlama']
        },
        {
          category: 'Marka Kimliği',
          items: ['Kurumsal evrak tasarımı', 'Mini marka rehberi', 'Kartvizit & antetli', 'Sosyal medya şablonları', 'Marka kullanım kuralları']
        },
        {
          category: 'Video İçerik',
          items: ['4 reel video üretimi', 'Motion graphic efektler', 'Profesyonel montaj', 'Müzik & ses tasarımı', 'Platform optimizasyonu']
        }
      ],
      borderColor: 'border-[#007dff]',
      accentColor: 'bg-[#007dff]',
      popular: true,
      bgColor: 'bg-gradient-to-br from-[#007dff] to-[#0066dd]',
      textColor: 'text-white',
    },
    {
      name: 'Premium Paket',
      subtitle: 'Marka Güçlendirme & Ölçekleme',
      price: '116.280 TL',
      originalPrice: '161.500 TL',
      discount: '%28',
      saving: '45.220 TL',
      slogan: 'Tüm dijital varlıkların profesyonel seviyede yönetimi ve ölçeklendirme',
      target: 'Pazar lideri olmak isteyen markalar',
      features: [
        {
          category: 'Sosyal Medya Yönetimi',
          items: ['16 Post tasarımı', '12 Story içeriği', 'Trend odaklı içerik', 'Topluluk yönetimi', 'Kriz yönetimi', 'Günlük etkileşim']
        },
        {
          category: 'Reklam Yönetimi',
          items: ['Çoklu kampanya yönetimi', 'İleri A/B testleri', 'Dönüşüm analizi', 'Remarketing stratejisi', 'ROI optimizasyonu', 'Haftalık strateji']
        },
        {
          category: 'Web Tasarım',
          items: ['10+ sayfa premium site', 'Çoklu dil desteği', 'SEO Premium optimizasyon', 'API entegrasyonları', 'Gelişmiş güvenlik', 'Performans izleme']
        },
        {
          category: 'CRM & AI Otomasyon',
          items: ['Çok kanallı otomasyon', 'AI destekli süreçler', 'Akıllı segmentasyon', 'Tahmine dayalı analiz', 'ERP entegrasyonu', 'Özel raporlama']
        },
        {
          category: 'Marka Kimliği',
          items: ['Tam kurumsal kimlik kılavuzu', 'Sosyal medya kit', 'Araç giydirme tasarımı', 'Ofis malzemeleri', 'Marka stratejisi workshop', 'Kullanım eğitimi']
        },
        {
          category: 'Video İçerik',
          items: ['6 reel video üretimi', 'Profesyonel çekim ekibi', 'Senaryo yazımı', 'İleri efekt & animasyon', 'Ses tasarımı', 'Çoklu platform optimizasyonu']
        }
      ],
      borderColor: 'border-[#007dff]',
      accentColor: 'bg-[#007dff]',
      popular: false,
    },
  ];

  return (
    <section ref={ref} className="py-12 pb-16 bg-white">
      <div className="max-w-[1440px] mx-auto px-8">
        <div className="grid lg:grid-cols-3 gap-6">
          {packages.map((pkg, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`relative rounded-2xl p-6 border-2 ${pkg.borderColor} ${
                pkg.popular ? `${pkg.bgColor} ${pkg.textColor} shadow-2xl` : 'bg-white shadow-lg'
              } transition-all duration-300 hover:shadow-2xl flex flex-col`}
            >
              {/* Popular Badge */}
              {pkg.popular && (
                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                  <div className="px-5 py-1.5 bg-white rounded-full shadow-lg">
                    <span className="font-poppins font-semibold text-xs text-[#007dff]">
                      En Popüler
                    </span>
                  </div>
                </div>
              )}

              {/* Package Name */}
              <h3 className={`font-poppins font-bold text-xl mb-1 ${pkg.popular ? 'text-white' : 'text-gray-900'}`}>
                {pkg.name}
              </h3>
              <p className={`font-poppins text-sm mb-3 ${pkg.popular ? 'text-white/80' : 'text-gray-600'}`}>
                {pkg.subtitle}
              </p>

              {/* Price */}
              <div className="mb-2">
                <div className="flex items-baseline gap-2 mb-1">
                  <span className={`font-poppins font-bold text-3xl ${pkg.popular ? 'text-white' : 'text-[#007dff]'}`}>
                    {pkg.price}
                  </span>
                  <span className={`font-poppins text-sm line-through ${pkg.popular ? 'text-white/60' : 'text-gray-400'}`}>
                    {pkg.originalPrice}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-semibold ${
                    pkg.popular ? 'bg-white/20 text-white' : 'bg-green-100 text-green-700'
                  }`}>
                    {pkg.discount} İndirim
                  </span>
                  <span className={`font-poppins text-xs ${pkg.popular ? 'text-white/80' : 'text-gray-600'}`}>
                    {pkg.saving} Kazanç
                  </span>
                </div>
              </div>

              {/* Target */}
              <div className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full mb-3 self-start ${
                pkg.popular ? 'bg-white/20' : 'bg-[#007dff]/10'
              }`}>
                <i className={`ri-user-star-line text-sm ${pkg.popular ? 'text-white' : 'text-[#007dff]'}`}></i>
                <span className={`font-poppins text-xs ${pkg.popular ? 'text-white' : 'text-[#007dff]'}`}>
                  {pkg.target}
                </span>
              </div>

              {/* Slogan */}
              <p className={`font-poppins text-sm mb-5 pb-5 border-b ${
                pkg.popular ? 'text-white/90 border-white/20' : 'text-gray-600 border-gray-200'
              }`}>
                🎯 {pkg.slogan}
              </p>

              {/* Features List */}
              <div className="flex-grow mb-5">
                <h4 className={`font-poppins font-semibold text-sm mb-3 ${pkg.popular ? 'text-white' : 'text-gray-900'}`}>
                  Paket İçeriği:
                </h4>
                <div className="space-y-4">
                  {pkg.features.map((feature, idx) => (
                    <div key={idx}>
                      <h5 className={`font-poppins font-semibold text-xs mb-2 ${
                        pkg.popular ? 'text-white/90' : 'text-gray-800'
                      }`}>
                        {feature.category}
                      </h5>
                      <ul className="space-y-1.5 ml-2">
                        {feature.items.map((item, itemIdx) => (
                          <li key={itemIdx} className="flex items-start gap-2">
                            <div className={`w-3 h-3 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5 ${
                              pkg.popular ? 'bg-white/20' : 'bg-[#007dff]/10'
                            }`}>
                              <i className={`ri-check-line text-[10px] ${pkg.popular ? 'text-white' : 'text-[#007dff]'}`}></i>
                            </div>
                            <span className={`font-poppins text-xs leading-relaxed ${
                              pkg.popular ? 'text-white/90' : 'text-gray-700'
                            }`}>
                              {item}
                            </span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>

              {/* CTA Button */}
              <button
                onClick={scrollToContact}
                className={`w-full py-3 rounded-xl font-poppins font-semibold text-sm transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  pkg.popular
                    ? 'bg-white text-[#007dff] hover:bg-white/90'
                    : `${pkg.accentColor} text-white hover:opacity-90`
                }`}
              >
                Hemen Başla
              </button>
            </motion.div>
          ))}
        </div>

        {/* Extra Benefits */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-12 bg-gradient-to-br from-[#007dff]/5 to-[#007dff]/10 rounded-2xl p-6 border border-[#007dff]/20"
        >
          <h3 className="font-poppins font-bold text-lg text-gray-900 mb-4 flex items-center gap-2">
            <i className="ri-gift-line text-[#007dff]"></i>
            Tüm Paketlerde Ek Avantajlar
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { icon: 'ri-calendar-check-line', title: 'Yıllık Sözleşme', desc: 'Ek %10 indirim fırsatı' },
              { icon: 'ri-line-chart-line', title: 'Gelişim Raporu', desc: 'Her ay detaylı analiz ve yol haritası' },
              { icon: 'ri-customer-service-2-line', title: 'Tek İletişim Noktası', desc: 'Tüm dijital süreç yönetimi' },
              { icon: 'ri-presentation-line', title: 'Workshop Hediye', desc: 'Marka stratejisi eğitimi' },
            ].map((benefit, idx) => (
              <div
                key={idx}
                className="flex flex-col gap-2 bg-white rounded-lg p-4 border border-gray-200 hover:border-[#007dff] transition-all duration-300"
              >
                <div className="w-10 h-10 flex items-center justify-center bg-[#007dff]/10 rounded-lg">
                  <i className={`${benefit.icon} text-[#007dff] text-xl`}></i>
                </div>
                <h4 className="font-poppins font-semibold text-sm text-gray-900">{benefit.title}</h4>
                <p className="font-poppins text-xs text-gray-600">{benefit.desc}</p>
              </div>
            ))}
          </div>
        </motion.div>

        {/* Bottom Note */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-center mt-8"
        >
          <p className="font-poppins text-sm text-gray-600 mb-3">
            📌 Tüm fiyatlar KDV hariçtir. Paketler özelleştirilebilir ve ihtiyaçlarınıza göre uyarlanabilir.
          </p>
          <button
            onClick={scrollToContact}
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-[#007dff] text-white rounded-lg font-poppins text-sm font-semibold hover:bg-[#0066dd] transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-calendar-line"></i>
            Ücretsiz Danışmanlık Al
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default PackageCards;
